<template>
  <div id="app">
    <AppHeader/>
    <AppMenuToggle/>
    <ModuleAppMenu/>
    <main class="app-main">
      <transition
        name="page--default-transition">
        <router-view
          :key="$route.path"/>
      </transition>
    </main>
    <AppFooter/>
  </div>
</template>

<script>
import ModuleAppMenu from '@/modules/ModuleAppMenu/ModuleAppMenu'
import AppMenuToggle from '@/components/AppMenuToggle/AppMenuToggle'
import AppHeader from '@/components/AppHeader/AppHeader'
import AppFooter from '@/components/AppFooter/AppFooter'
import {titleTemplate, url} from '@/meta/metaConfig'
import { mapGetters } from 'vuex'
import iosHack from '@/utils/iosHack'
import toggleStopScroll from '@/utils/toggleStopScroll'
export default {
  name: 'App',
  components: {
    ModuleAppMenu,
    AppFooter,
    AppHeader,
    AppMenuToggle
  },
  metaInfo () {
    return {
      title: 'Bröderna Klemensson Fjällkött',
      titleTemplate: `%s - ${titleTemplate}`,
      link: [
        {
          rel: 'canonical',
          href: url,
          vmid: 'canonical'
        }
      ]
    }
  },
  methods: {

  },
  computed: {
    ...mapGetters({
      isStopScroll: 'ui/isStopScroll'
    })
  },
  beforeMount () {
    iosHack()
  },
  watch: {
    isStopScroll: function () {
      toggleStopScroll(this.isStopScroll)
    }
  }
}
</script>
<style lang="scss">
  @import "./src/scss/app";
</style>



// WEBPACK FOOTER //
// src/App.vue